module.exports = __webpack_public_path__ + "assets/dd04e8f1599fceb1ecaf29f178ebc8b4.svg";